// One-time starter data offered when no lead times exist yet, so the manager
// starts from the current Marvin / Andersen lists instead of a blank page.
// Values are free text on purpose — ranges ("5-7 weeks") and split values
// ("8 weeks traditional / 8 weeks contemporary") are all real lead times.
const makeId = () => Math.random().toString(36).slice(2, 10);

const section = (title, items) => ({
  id: makeId(),
  title,
  items: items.map(([product, was, now, note]) => ({
    id: makeId(),
    product,
    was,
    now,
    note: note || "",
  })),
});

export const starterBrands = () => [
  {
    brand: "Marvin",
    brandKey: "marvin",
    effectiveDate: "2026-07-20",
    sortOrder: 1,
    sections: [
      section("Signature Ultimate", [
        ["Windows", "12 weeks", "12 weeks", "Wood Ext / Wood Int 16 weeks"],
        [
          "Polygon Fixed, Rectangle Fixed, Gliding Windows",
          "12 weeks",
          "12 weeks",
        ],
        ["Roundtop", "12 weeks", "12 weeks"],
        ["Sliding Doors", "11 weeks", "11 weeks"],
        ["Swinging Doors", "11 weeks", "11 weeks"],
        ["BiFold / Multi-Slide Doors", "11 weeks", "11 weeks"],
        ["Lift & Slide Doors", "11 weeks", "11 weeks"],
      ]),
      section("Signature Modern", [["All Products", "10 weeks", "10 weeks"]]),
      section("Elevate", [["All Products", "8 weeks", "7 weeks"]]),
      section("Essential", [["All Products", "8 weeks", "7 weeks"]]),
      section("Vivid", [["All Products", "7 weeks", "9 weeks"]]),
    ],
  },
  {
    brand: "Andersen",
    brandKey: "andersen",
    effectiveDate: "2026-07-14",
    sortOrder: 2,
    sections: [
      section("100 Series", [
        ["Windows", "5-7 weeks", "5-8 weeks"],
        ["Patio Door", "6 weeks", "7 weeks"],
      ]),
      section("200 Series", [
        ["Windows", "7 weeks", "6 weeks"],
        ["PS Doors", "4 weeks", "4 weeks"],
        ["NLGD Doors", "6 weeks", "6 weeks"],
        ["Inswing Patio Door", "8 weeks", "8 weeks"],
      ]),
      section("400 Series", [
        ["CSMT / AWN Windows", "5 weeks", "5 weeks"],
        ["TW Windows", "4 weeks", "4 weeks"],
        ["WW Windows", "7 weeks", "6 weeks"],
        ["Glider Windows", "4 weeks", "4 weeks"],
        ["Flexiframe Windows", "8 weeks", "7 weeks"],
        ["FWG Doors", "6 weeks", "6 weeks"],
        ["FWH Doors", "6 weeks", "7 weeks"],
      ]),
      section("Specialty", [
        ["Andersen Specialty Windows", "11 weeks", "10 weeks"],
      ]),
      section("A Series", [
        [
          "Windows",
          "7 weeks traditional / 7 weeks contemporary",
          "8 weeks traditional / 8 weeks contemporary",
        ],
        [
          "Gliding Patio Doors",
          "6 weeks",
          "6 weeks",
          'Door units taller than 95.5" are 8 weeks',
        ],
        [
          "Inswing Hinged Patio Door",
          "6 weeks",
          "6 weeks",
          'Door units taller than 95.5" are 8 weeks',
        ],
        [
          "Outswing Hinged Patio Door",
          "5 weeks",
          "6 weeks",
          'Door units taller than 95.5" are 8 weeks',
        ],
      ]),
      section("E Series", [
        ["Windows", "9-16 weeks", "9-16 weeks"],
        ["Gliding Patio Doors", "7 weeks", "7 weeks"],
        ["Hinged Patio Doors", "15 weeks", "14 weeks"],
      ]),
      section("Specialty Doors", [
        ["MultiGlide Doors", "8 weeks", "8 weeks"],
        ["Folding Doors", "11 weeks", "11 weeks"],
        ["Pivot / LiftSlide Doors", "13 weeks", "13 weeks"],
        ["Entranceway Doors", "11 weeks", "11 weeks"],
        ["Storm Doors - Standard Size", "4 weeks", "4 weeks"],
        ["Storm Doors - Custom Size", "4 weeks", "4 weeks"],
      ]),
    ],
  },
];
